import { Box } from '@mui/material';
import { NamedLayoutBlock } from 'src/components';
import { BlockedEmailsTable } from './blocked-contacts-table';

export const BlockedContactsView = () => {
  return (
    <NamedLayoutBlock
      BlockContentProps={{
        sx: {
          overflow: 'hidden',
          height: '100vh',
        },
      }}
      title="Blocked Contacts"
      sx={{
        flex: 1,
        display: { sm: 'flex' },
      }}
    >
      <Box>
        <BlockedEmailsTable />
      </Box>
    </NamedLayoutBlock>
  );
};
